import {useAui} from '@assistant-ui/react';
import {useCallback} from 'react';

import type {AgentChatThreadExtras} from './extras';

/**
 * useReloadThread returns a function that re-fetches a thread by root turn id,
 * bypassing AUI's `switchToThread` no-op guard for the already-active thread.
 * Use it to retry a failed load.
 */
export function useReloadThread(): (rootTurnId: string) => Promise<void> {
  const aui = useAui();
  return useCallback(
    rootTurnId => {
      const extras = aui.thread().getState().extras as AgentChatThreadExtras;
      return extras.reloadThread(rootTurnId);
    },
    [aui]
  );
}
